import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export interface GetMaintenanceAnalyticsRequest {
  buildingId?: number
  startDate: number
  endDate: number
}

export interface GetMaintenanceAnalyticsResponse {
  avgTimeToAssign: number
  avgTimeToSchedule: number
  avgTimeToClose: number
  totalOpen: number
  totalPending: number
  totalScheduled: number
  totalClosed: number
}

export const MAINTENANCE_ANALYTICS_BASE_QUERY_KEY = 'useGetMaintenanceAnalytics'

export const getMaintenanceAnalyticsQueryKey = (data: GetMaintenanceAnalyticsRequest) => [
  MAINTENANCE_ANALYTICS_BASE_QUERY_KEY,
  data,
]

export const getMaintenanceAnalytics = async (
  params: GetMaintenanceAnalyticsRequest,
  signal?: AbortSignal,
): Promise<GetMaintenanceAnalyticsResponse> => {
  const { buildingId, ...rest } = params
  const response = await authAPI.get<GetMaintenanceAnalyticsResponse>(
    '/v2/maintenance/pm/analytics',
    { params: { ...rest, buildingId }, signal },
  )
  return response.data
}

export const useGetMaintenanceAnalytics = (data: GetMaintenanceAnalyticsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: ({ signal }) => getMaintenanceAnalytics(data, signal),
    queryKey: getMaintenanceAnalyticsQueryKey(data),
  })
}
